import { render, staticRenderFns } from "./SidePanelProductLines.vue?vue&type=template&id=6965197f&scoped=true"
import script from "./SidePanelProductLines.vue?vue&type=script&lang=ts"
export * from "./SidePanelProductLines.vue?vue&type=script&lang=ts"
import style0 from "./SidePanelProductLines.vue?vue&type=style&index=0&id=6965197f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965197f",
  null
  
)

export default component.exports